import { useEffect, useState } from 'react';
import {
  EXPERIENCE_TAGS as PROMO_EXPERIENCE_TAGS
} from '@thd-olt-component-react/promotion-products/dist/utils/constants';
import { useConfigService } from '@thd-nucleus/experience-context';

export default () => {
  const [enabledPromoTypes, setEnabledPromoTypes] = useState([]);

  const bmsmEnabled = useConfigService('fs-prop:grouped-promotions-bmsm-enabled');
  const bogoEnabled = useConfigService('fs-prop:grouped-promotions-bogo-enabled');
  const msbOnlineEnabled = useConfigService('fs-prop:grouped-promotions-msbonline-enabled');

  useEffect(() => {
    let types = [];
    if (bmsmEnabled) {
      types.push(PROMO_EXPERIENCE_TAGS.BMSM);
    }
    if (bogoEnabled) {
      types.push(PROMO_EXPERIENCE_TAGS.BOGO);
    }
    if (msbOnlineEnabled) {
      types.push(PROMO_EXPERIENCE_TAGS.MSB);
    }
    setEnabledPromoTypes(types);

  }, [bmsmEnabled, bogoEnabled, msbOnlineEnabled]);

  return enabledPromoTypes;
};
